<template>
    <el-dialog
        :visible.sync="dialogVisiable"
        :close-on-click-modal="false"
        custom-class="position-center"
        top="0"
        width="620px"
    >
        <div class="form-title">找回密码</div>

        <div class="form">
            <div class="form-body">
                <el-form :model="form" :rules="rules" ref="form">
                    <el-form-item prop="phone">
                        <el-input
                            v-model="form.phone"
                            placeholder="手机号"
                            clearable
                            autocomplete="new-password"
                            maxlength="11"
                        ></el-input>
                    </el-form-item>

                    <el-form-item prop="imgCode" class="el-form-code">
                        <el-input
                            v-model="form.imgCode"
                            placeholder="输入验证码"
                            clearable
                            autocomplete="new-password"
                            maxlength="4"
                        ></el-input>

                        <div class="code-img" @click="handleGetImg">
                            <div class="img">
                                <el-image :src="captchaImg" alt="验证码">
                                    <div slot="placeholder">加载中...</div>
                                </el-image>
                            </div>
                            <span>换一张</span>
                        </div>
                    </el-form-item>

                    <el-form-item prop="phoneCode" class="el-form-vcode">
                        <el-input
                            v-model="form.phoneCode"
                            placeholder="输入验证码"
                            clearable
                            autocomplete="new-password"
                            maxlength="6"
                        ></el-input>

                        <el-button
                            type="primary"
                            plain
                            :loading="isMsgSending"
                            :disabled="!form.phone || !form.imgCode || isMsgCounting"
                            @click="handleGetMsg"
                        >{{isMsgCounting ? msgSendSecond + '秒后可重发' : '获取验证码'}}</el-button>
                    </el-form-item>

                    <el-form-item prop="password">
                        <el-input
                            v-model="form.password"
                            type="password"
                             maxlength="12"
                            placeholder="请输入6-12位数字与字符组合的密码"
                            clearable
                            autocomplete="new-password"
                        ></el-input>
                    </el-form-item>

                    <el-form-item prop="newPassword">
                        <el-input
                            v-model="form.newPassword"
                            type="password"
                             maxlength="12"
                            placeholder="请再次输入密码"
                            clearable
                            autocomplete="new-password"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="form-footer">
                <el-button
                    type="primary"
                    :disabled="!isFormSubmit"
                    :loading="sending"
                    @click="handleFormSubmit"
                >提 交</el-button>
                <div class="cancel-link" @click="dialogVisiable = false">取消</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getCaptchaImage, getMsg } from '@/api/common';
import { findPass } from '@/api/account';

import {
  validatePhone,
  validateImgCode,
  validatePhoneCode,
  validatePassword,
} from '@/validate';

export default {
  name: 'CDialogForget',
  data() {
    const validateNewPass = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      dialogVisiable: false,
      sending: false,

      isMsgSending: false,
      isMsgCounting: false,
      msgSendSecond: 60,
      msgSendTime: null,

      isFormSubmit: false,
      captchaImg: '',

      form: {
        phone: '',
        imgCode: '',
        phoneCode: '',
        password: '',
        newPassword: '',
      },
      rules: {
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        imgCode: [{ required: true, validator: validateImgCode, trigger: 'blur' }],
        phoneCode: [{ required: true, validator: validatePhoneCode, trigger: 'blur' }],
        password: [{ required: true, validator: validatePassword, trigger: 'blur' }],
        newPassword: [
          { required: true, validator: validatePassword, trigger: 'blur' },
          { required: true, validator: validateNewPass, trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    form: {
      handler(value) {
        let tmpPass = true;

        Object.keys(value).forEach((key) => {
          if (value[key] === '') {
            tmpPass = false;
          }
        });

        this.isFormSubmit = tmpPass;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 弹出框初始化
    handleOpen() {
      if (this.dialogVisiable) {
        return false;
      }

      this.dialogVisiable = true;

      this.$nextTick(() => {
        // 图形验证码
        this.handleGetImg();

        // 短信验证码操作重置
        this.isMsgCounting = false;
        this.isMsgSending = false;
        this.msgSendSecond = 60;

        this.$refs.form.resetFields();
      });
    },

    // 获取图片验证码
    handleGetImg() {
      getCaptchaImage()
        .then((res) => {
          this.form.imgCode = '';
          this.captchaImg = res;
        })
        .catch(() => {});
    },
    // 获取短信验证码
    handleGetMsg() {
      let validateCount = 2;

      if (this.isMsgSending) {
        return false;
      }

      // 校验手机号码和图片验证码
      this.$refs.form.validateField(['phone', 'imgCode'], (errorMsg) => {
        validateCount = !errorMsg ? (validateCount - 1) : validateCount;

        if (validateCount === 0) {
          this.isMsgSending = true;

          getMsg({
            phone: this.form.phone,
            imgCode: this.form.imgCode,
            type: 0,
          })
            .then((res) => {
              this.isMsgSending = false;

              if (res.data === 0) {
                this.$message({
                  type: 'error',
                  showClose: true,
                  message: '该手机号不存在',
                });

                return false;
              }

              this.$message({
                type: 'success',
                showClose: true,
                message: '验证码发送成功',
              });

              // 倒计时
              this.msgSendSecond = 60;
              this.isMsgCounting = true;
              this.handleCountdown();
            })
            .catch(() => {
              this.isMsgSending = false;

              // this.handleGetImg();
            });
        }
      });
    },

    // 倒计时
    handleCountdown() {
      clearTimeout(this.msgSendTime);

      this.msgSendTime = setTimeout(() => {
        this.msgSendSecond -= 1;

        if (this.msgSendSecond > 0) {
          this.handleCountdown();
        } else {
          this.isMsgCounting = false;
        }
      }, 1000);
    },

    // 提交
    handleFormSubmit() {
      if (this.sending) {
        return false;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sending = true;

          findPass({
            phone: this.form.phone,
            // imgCode: this.form.imgCode,
            sms_code: this.form.phoneCode,
            new_pwd: this.$md5(this.form.password),
          }).then(() => {
            this.dialogVisiable = false;
            this.sending = false;

            this.$emit('success');

            this.$message({
              type: 'success',
              message: '密码修改成功！',
            });
          }).catch(() => {
            this.sending = false;

            this.handleGetImg();
          });
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.form {
    padding-left: 64px;
}

.form-title {
    padding-left: 64px;
    padding-top: 6px;
}

.el-form-vcode,
.el-form-code {
    .el-input {
        width: 270px;
    }
}
</style>
